import { createReducer } from '@reduxjs/toolkit';
import { set_show_filter } from '../confg';

const filterShowReducer = createReducer(false, {
  [set_show_filter]: (state, action) => action.payload
});

export default filterShowReducer;
